import { ClientPanels, ClientTabs } from "slot-definitions"
import { TabPanel } from "@mui/lab"
import { Advanced } from "routes/client-admin/plugins/advanced-config/advanced"
import { SecureTab } from "minimals-template/components/secure-tabs"
import { Frag } from "lib/@components/slot/frag"

ClientPanels.plug(
    <TabPanel value="Advanced">
        <Advanced $lazy />
    </TabPanel>
)

ClientTabs.plug(
    <SecureTab
        priority={1010}
        demand={"admin-advanced"}
        hide={true}
        fallback={<Frag />}
        label="Advanced"
        value="Advanced"
    />
)
